import {
  getReferralProgram as publicGetReferralProgram,
  bulkGetReferralProgram as publicBulkGetReferralProgram,
  updateReferralProgram as publicUpdateReferralProgram,
  activateReferralProgram as publicActivateReferralProgram,
  pauseReferralProgram as publicPauseReferralProgram,
  getAiSocialMediaPostsSuggestions as publicGetAiSocialMediaPostsSuggestions,
  generateAiSocialMediaPostsSuggestions as publicGenerateAiSocialMediaPostsSuggestions,
  getReferralProgramPremiumFeatures as publicGetReferralProgramPremiumFeatures,
} from './loyalty-referral-v1-program-programs.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onProgramUpdated as publicOnProgramUpdated } from './loyalty-referral-v1-program-programs.public.js';

export const getReferralProgram: MaybeContext<
  BuildRESTFunction<typeof publicGetReferralProgram> &
    typeof publicGetReferralProgram
> = /*#__PURE__*/ createRESTModule(publicGetReferralProgram);
/** @internal */
export const bulkGetReferralProgram: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetReferralProgram> &
    typeof publicBulkGetReferralProgram
> = /*#__PURE__*/ createRESTModule(publicBulkGetReferralProgram);
export const updateReferralProgram: MaybeContext<
  BuildRESTFunction<typeof publicUpdateReferralProgram> &
    typeof publicUpdateReferralProgram
> = /*#__PURE__*/ createRESTModule(publicUpdateReferralProgram);
export const activateReferralProgram: MaybeContext<
  BuildRESTFunction<typeof publicActivateReferralProgram> &
    typeof publicActivateReferralProgram
> = /*#__PURE__*/ createRESTModule(publicActivateReferralProgram);
export const pauseReferralProgram: MaybeContext<
  BuildRESTFunction<typeof publicPauseReferralProgram> &
    typeof publicPauseReferralProgram
> = /*#__PURE__*/ createRESTModule(publicPauseReferralProgram);
export const getAiSocialMediaPostsSuggestions: MaybeContext<
  BuildRESTFunction<typeof publicGetAiSocialMediaPostsSuggestions> &
    typeof publicGetAiSocialMediaPostsSuggestions
> = /*#__PURE__*/ createRESTModule(publicGetAiSocialMediaPostsSuggestions);
export const generateAiSocialMediaPostsSuggestions: MaybeContext<
  BuildRESTFunction<typeof publicGenerateAiSocialMediaPostsSuggestions> &
    typeof publicGenerateAiSocialMediaPostsSuggestions
> = /*#__PURE__*/ createRESTModule(publicGenerateAiSocialMediaPostsSuggestions);
export const getReferralProgramPremiumFeatures: MaybeContext<
  BuildRESTFunction<typeof publicGetReferralProgramPremiumFeatures> &
    typeof publicGetReferralProgramPremiumFeatures
> = /*#__PURE__*/ createRESTModule(publicGetReferralProgramPremiumFeatures);
/**
 * Triggered when a referral program is updated.
 */
export const onProgramUpdated: BuildEventDefinition<
  typeof publicOnProgramUpdated
> &
  typeof publicOnProgramUpdated = createEventModule(publicOnProgramUpdated);

export {
  ProgramStatus,
  RewardType,
  DiscountType,
  Action,
  App,
  ProviderName,
  IntervalUnit,
  SubscriptionStatus,
  ReactivationReasonEnum,
  Initiator,
  RefundType,
  UnassignReason,
  ContractSwitchType,
  ContractSwitchReason,
  PriceIncreaseTrigger,
  ProductAdjustment,
  Type,
  WebhookIdentityType,
} from './loyalty-referral-v1-program-programs.universal.js';
export {
  ReferralProgram,
  Reward,
  RewardOptionsOneOf,
  Coupon,
  CouponDiscountTypeOptionsOneOf,
  CouponScopeOrMinSubtotalOneOf,
  FixedAmountDiscount,
  PercentageDiscount,
  CouponScope,
  Group,
  LoyaltyPoints,
  Emails,
  PremiumFeatures,
  GetReferralProgramRequest,
  GetReferralProgramResponse,
  BulkGetReferralProgramRequest,
  BulkGetReferralProgramResponse,
  ProgramInSite,
  UpdateReferralProgramRequest,
  UpdateReferralProgramResponse,
  ActivateReferralProgramRequest,
  ActivateReferralProgramResponse,
  PauseReferralProgramRequest,
  PauseReferralProgramResponse,
  GetAISocialMediaPostsSuggestionsRequest,
  GetAISocialMediaPostsSuggestionsResponse,
  AISocialMediaPostSuggestion,
  GenerateAISocialMediaPostsSuggestionsRequest,
  GenerateAISocialMediaPostsSuggestionsResponse,
  GetReferralProgramPremiumFeaturesRequest,
  GetReferralProgramPremiumFeaturesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  HtmlSitePublished,
  Page,
  SubscriptionEvent,
  SubscriptionEventEventOneOf,
  SubscriptionCreated,
  Subscription,
  BillingReference,
  Cycle,
  CycleCycleSelectorOneOf,
  Interval,
  OneTime,
  ReactivationData,
  SubscriptionAssigned,
  SubscriptionCancelled,
  CancellationDetails,
  SubscriptionAutoRenewTurnedOn,
  SubscriptionAutoRenewTurnedOff,
  SubscriptionUnassigned,
  SubscriptionTransferred,
  RecurringChargeSucceeded,
  ContractSwitched,
  ProductPriceIncreaseData,
  SubscriptionNearEndOfPeriod,
  SubscriptionPendingChange,
  RecurringChargeAttemptFailed,
  SubscriptionUpdated,
  SubscriptionMigratedFromVista,
  SubscriptionVistaMigrationReverted,
  ReferralAppInstallation,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ProgramUpdatedEnvelope,
  GetAiSocialMediaPostsSuggestionsOptions,
  GenerateAiSocialMediaPostsSuggestionsOptions,
} from './loyalty-referral-v1-program-programs.universal.js';
export {
  ProgramStatusWithLiterals,
  RewardTypeWithLiterals,
  DiscountTypeWithLiterals,
  ActionWithLiterals,
  AppWithLiterals,
  ProviderNameWithLiterals,
  IntervalUnitWithLiterals,
  SubscriptionStatusWithLiterals,
  ReactivationReasonEnumWithLiterals,
  InitiatorWithLiterals,
  RefundTypeWithLiterals,
  UnassignReasonWithLiterals,
  ContractSwitchTypeWithLiterals,
  ContractSwitchReasonWithLiterals,
  PriceIncreaseTriggerWithLiterals,
  ProductAdjustmentWithLiterals,
  TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './loyalty-referral-v1-program-programs.universal.js';
